import { useState, useRef, useEffect } from 'react'

const MultiSelectDropdown = ({ options, selected, onChange, label }) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const toggleOption = (option) => {
    if (selected.includes(option)) {
      // Don't allow deselecting all
      if (selected.length > 1) {
        onChange(selected.filter((s) => s !== option))
      }
    } else {
      onChange([...selected, option])
    }
  }

  const selectAll = () => onChange([...options])
  const clearAll = () => onChange([options[0]]) // Keep at least one

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        className="mt-3 px-3 py-2 rounded-md border bg-white dark:bg-darkbg4 text-sm min-w-[140px] text-left flex justify-between items-center hover:bg-gray-50 dark:hover:bg-gray-700"
      >
        <span className="truncate">
          {selected.length === options.length
            ? `All ${label}`
            : selected.length === 1
            ? selected[0]
            : `${selected.length} ${label}`}
        </span>
        <span className="ml-2 text-xs opacity-70">▼</span>
      </button>

      {isOpen && (
        <div className="absolute z-50 mt-1 w-full bg-white dark:bg-darkbg4 border dark:border-gray-600 rounded-md shadow-lg max-h-60 overflow-auto">
          {/* Select All / Clear */}
          <div className="flex justify-between px-3 py-2 border-b dark:border-gray-600 text-xs">
            <button onClick={selectAll} type="button" className="text-blue-500 hover:underline">
              Select All
            </button>
            <button onClick={clearAll} type="button" className="text-gray-500 hover:underline">
              Clear
            </button>
          </div>

          {/* Options */}
          {options.map((option) => (
            <label
              key={option}
              className="flex items-center px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm"
            >
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={() => toggleOption(option)}
                className="mr-2 accent-blue-500"
              />
              <span className="dark:text-white">{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  )
}

export default MultiSelectDropdown
